import { useLike } from "@/hooks/useLike";
import { IconButton } from "@material-ui/core";
import FavoriteBorderOutlinedIcon from "@material-ui/icons/FavoriteBorderOutlined";
import FavoriteOutlinedIcon from "@material-ui/icons/FavoriteOutlined";
import { useEffect } from "react";
import styles from "./styles.module.less";

interface IProps {
  fatherId: string;
  className?: string;
  init?: boolean;
  url?: string;
}

const LikeIcon: React.FC<IProps> = ({ fatherId, className, init, url }) => {
  const {
    handleLike: _handleLike,
    getLike,
    likedTimeCount,
    likedStatus,
    loading,
  } = useLike(fatherId);

  useEffect(() => {
    if (!init) {
      getLike();
    }
  }, [init]);

  const handleLike = () => _handleLike(url);

  return (
    <IconButton disabled={loading} onClick={handleLike} className={className}>
      {likedStatus ? (
        <FavoriteOutlinedIcon color="primary" />
      ) : (
        <FavoriteBorderOutlinedIcon />
      )}
      <span className={styles.color}>{likedTimeCount}</span>
    </IconButton>
  );
};

export default LikeIcon;
